/**
 * openProgramWorkstation — ask for the workstation window (docs/PLAN-windows-workstation-20261009.md, W2).
 *
 * Every surface that offers a desktop program (the Legal apps rows, the chat's card, onboarding) opens the same
 * window by sending this one event; ProgramWorkstationModalHost, on the first download, listens for it and loads the
 * window through its door. Tiny on purpose: it rides wherever a button does.
 */
export const PROGRAM_WORKSTATION_EVENT = 'prest0n:program-workstation';
/** Sent by the window when the person presses done: the rows that list the program read it again. */
export const PROGRAM_WORKSTATION_SIGNED_IN_EVENT = 'prest0n:program-workstation-signed-in';

export interface ProgramWorkstationRequest {
  /** The program to open there (the server's WORKSTATION_PROGRAMS: 'lexpi'). */
  program: string;
  /** The program's name as people know it ("LexPI"). */
  programName: string;
  /** The workspace whose workstation it is. */
  accountId: string;
  /** The language of the conversation or page that asked. */
  lang?: 'en' | 'es';
}

/** PURE. A request as the host keeps it, or null when it names nothing it can open. */
export function programWorkstationRequestOf(detail: unknown): ProgramWorkstationRequest | null {
  const d = detail && typeof detail === 'object' ? (detail as Record<string, unknown>) : null;
  if (!d) return null;
  const program = typeof d.program === 'string' && /^[a-z0-9-]{1,40}$/.test(d.program) ? d.program : '';
  const accountId = typeof d.accountId === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(d.accountId) ? d.accountId : '';
  const programName = typeof d.programName === 'string' ? d.programName.trim().slice(0, 60) : '';
  if (!program || !accountId || !programName) return null;
  return { program, programName, accountId, ...(d.lang === 'es' || d.lang === 'en' ? { lang: d.lang } : {}) };
}

export function openProgramWorkstation(request: ProgramWorkstationRequest): void {
  if (typeof document === 'undefined') return;
  document.dispatchEvent(new CustomEvent(PROGRAM_WORKSTATION_EVENT, { detail: request }));
}
